module.exports = __webpack_public_path__ + "static/media/sv-SE.7fb117e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/sv-SE.png
// module id = 955
// module chunks = 0